export const SYSTEM_SETTING_USER_STORE = 'SYSTEM_SETTING_USER_STORE';
export const SYSTEM_SETTING_USER_STORE_SUCCESS = 'SYSTEM_SETTING_USER_STORE_SUCCESS';
export const SYSTEM_SETTING_USER_SEARCH = 'SYSTEM_SETTING_USER_SEARCH';
